import { createFileRoute } from "@tanstack/react-router";

// UI
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Route = createFileRoute(
  "/_layout-private/account-management/soe/"
)({
  component: SOEComponent,
});

function SOEComponent() {
  return (
    <section>
      <p className="text-[14px] mb-[32px]">ຈັດການຂໍ້ມູນບໍລິສັດ</p>

      <Card>
        <CardHeader>
          <CardTitle>ຂໍ້ມູນລັດວິສາຫະກິດ</CardTitle>
          <CardDescription>ຕາຕະລາງຂໍ້ມູນລັດວິສາຫະກິດທັງໝົດ</CardDescription>
        </CardHeader>
        <CardContent></CardContent>
        {/* <CardFooter>
					<p>Card Footer</p>
				</CardFooter> */}
      </Card>
    </section>
  );
}
